// 화면3 — 세이프가드 더미 데이터

// 세이프가드 종합 상태: 'safe' | 'blocked' | 'rollback_wait'
export const overallStatus = 'safe';

export const overallStatusMeta = {
  safe: { labelKey: 'pages.modulec.overallStatus.safe', color: '#22c55e', bg: 'rgba(34,197,94,0.12)', icon: 'verified_user' },
  blocked: { labelKey: 'pages.modulec.overallStatus.blocked', color: '#ef4444', bg: 'rgba(239,68,68,0.12)', icon: 'block' },
  rollback_wait: { labelKey: 'pages.modulec.overallStatus.rollbackWait', color: '#fbbf24', bg: 'rgba(251,191,36,0.12)', icon: 'history' },
};

// ② 롤백·변경이력 로그
export const changeLog = [
  { ts: '14:33:40', paramKey: 'pages.modulec.params.moldTemp', from: '52℃', to: '58℃', actorKey: 'pages.modulec.worker.name', status: 'applied' },
  { ts: '14:33:40', paramKey: 'pages.modulec.params.coolingTime', from: '18.0s', to: '16.5s', actorKey: 'pages.modulec.worker.name', status: 'applied' },
  { ts: '14:33:40', paramKey: 'pages.modulec.params.injectionPressure', from: '118.0MPa', to: '124.5MPa', actorKey: 'pages.modulec.worker.name', status: 'applied' },
  { ts: '13:05:12', paramKey: 'pages.modulec.params.holdingPressure', from: '58MPa', to: '60MPa', actorKey: 'pages.modulec.worker.name2', status: 'applied' },
  { ts: '11:48:33', paramKey: 'pages.modulec.params.moldTemp', from: '55℃', to: '52℃', actorKey: 'pages.modulec.worker.aiAuto', status: 'rolledback' },
  { ts: '10:22:07', paramKey: 'pages.modulec.params.injectionSpeed', from: '82mm/s', to: '78mm/s', actorKey: 'pages.modulec.worker.name2', status: 'applied' },
];

export const changeLogStatusMeta = {
  applied: { labelKey: 'pages.modulec.changeLogStatus.applied', color: '#22c55e', bg: 'rgba(34,197,94,0.12)' },
  rolledback: { labelKey: 'pages.modulec.changeLogStatus.rolledback', color: '#fbbf24', bg: 'rgba(251,191,36,0.12)' },
  blocked: { labelKey: 'pages.modulec.changeLogStatus.blocked', color: '#ef4444', bg: 'rgba(239,68,68,0.12)' },
};

// ③ in-silico 사전검증 (디지털트윈 가상 검증)
export const inSilico = {
  baselineDefectRate: 4.7,   // 적용 전 예상 불량률(%)
  predictedDefectRate: 3.1,  // 가상 검증 예상 불량률(%)
  passed: true,
  noteKey: 'pages.modulec.safeguard.silicoNote',
};

// 하단 적용 전/후 불량률 추이 (라인차트)
// applied 시점 전후로 불량률이 저감되는 시계열
export const defectTrend = (() => {
  const data = [];
  for (let i = 0; i < 24; i++) {
    const phase = i < 12 ? 'before' : 'after';
    // 적용 전 4.4~5.0, 적용 후 2.9~3.5 근처
    const base = i < 12 ? 4.7 : 3.2;
    const wave = Math.sin(i * 0.9) * 0.28 + ((i * 7) % 5) * 0.05;
    data.push({
      idx: i + 1,
      hour: 8 + i,
      rate: Math.round((base + wave) * 100) / 100,
      phase,
    });
  }
  return data;
})();

export const beforeAfterKpi = {
  beforeRate: 4.7,        // 적용 전 평균 불량률(%)
  afterRate: 3.2,         // 적용 후 평균 불량률(%)
  reduction: -30,         // 저감률(%)
  pValue: 0.012,          // t-test p값
  cumulativeShots: 3480,  // 누적 적용 샷 수
  appliedAtIdx: 12,       // 적용 시점 인덱스
};
